export const textureChangeFrame = (sprite, texture) => {
  sprite.texture = texture;
};
